import React, { useState, useContext, useEffect, useRef } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import "./posquickinvice.css";
import defaultImage from "../../../../../assets/Image/placeholderImage.jpg";
import invoiceIcon from "../.././../../../assets/Image/invoice.png";
import dateIcon from "../.././../../../assets/Image/calendar.png";
import LoadingOverlay from "../../../../common/LoadingBar.js";
import loader from "../../../../../assets/Image/Loader2.gif";
import SwipeInComponent from "./SwipeInComponent";
import { useToastHandler } from "../../../../common/ToastHandler";
import useFormattingUtils from "../../../../../context/useFormattingUtils";
import CustomDateInput from "../../../../../context/CustomDateInput";
import QuickInvoicemodal from "./QuickInvoicemodal";
import { runCloverLocalSale } from "../../../../../utils/clover/cloverConnector";
import { useShift } from "../../Lottery/ShiftContext";

const CARD_SIZE_STORAGE_KEY = "paisaVaraQuickInvoiceProductCardSize";
const CARD_SIZE_OPTIONS = [
  { key: "compact", label: "Compact" },
  { key: "comfort", label: "Comfort" },
  { key: "spacious", label: "Large" },
];

const getInitialProductCardSize = () => {
  try {
    const saved = window.localStorage.getItem(CARD_SIZE_STORAGE_KEY);
    return CARD_SIZE_OPTIONS.some((option) => option.key === saved) ? saved : "comfort";
  } catch (error) {
    return "comfort";
  }
};
function PosQuickInvoice() {
  const { formatCurrency } = useFormattingUtils();
  const [, setActiveButton] = useState("");
  const [loading, setLoading] = useState(true);
  const [addedProducts, setAddedProducts] = useState([]);
  const mainContainerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isSwipeOpen, setIsSwipeOpen] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [productsvalue, setProductsvalue] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [productCardSize, setProductCardSize] = useState(getInitialProductCardSize);
  const [productQuantities, setProductQuantities] = useState({});
  const fetchingRef = useRef(false);
  const { handleToast } = useToastHandler();
  const [totals, setTotals] = useState({
    totalQty: 0,
    totalAmount: 0,
    roundedValue: 0,
    roundOff: 0,
    productAmounts: {},
  });
  const [showInvoice, setShowInvoice] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [roundOffEnabled, setRoundOffEnabled] = useState(true);
  const [additionalDiscount] = useState("0");
  const [terminals, setTerminals] = useState([]);
  const [selectedTerminal, setSelectedTerminal] = useState(null);
  const [showTerminalModal, setShowTerminalModal] = useState(false);
  const [terminalStatus, setTerminalStatus] = useState("IDLE");
  const [terminalMessage, setTerminalMessage] = useState("");
  const { shiftData, startShift } = useShift();
  const [showShiftRequiredModal, setShowShiftRequiredModal] = useState(false);
  const [startingShiftForSale, setStartingShiftForSale] = useState(false);
  const [pendingSubmitOpenModal, setPendingSubmitOpenModal] = useState(false);
  const pollingRef = useRef(null);
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const { Post, getAPI, getHost, Get, Patch } = useApi();

  const debounceRef = useRef(null);
  const [formData, setFormData] = useState({
    store: user.store,
    date: new Date().toISOString().split("T")[0],
    invoice_no: "",
    customer: "",
    additional_discount_value: "0",
    bank: "",
    cheque_no: "",
    note: "",
    pay_method: "cash",
    pay_method_status: "pay_now",
  });
  useEffect(() => {
    const onScroll = () => setScrollPosition(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);
  useEffect(() => {
    if (user?.store) {
      Get(`${getAPI('paymentTerminals')}?store_id=${user.store}`)
        .then((data) => {
          setTerminals(data || []);
          if (data && data.length > 0) {
            const def = data.find((t) => t.is_default) || data[0];
            setSelectedTerminal(def);
          }
        })
        .catch((err) => console.error("Error fetching terminals:", err));

      Get(`${getAPI('configurationForStore')}?store=${user.store}`)
        .then((res) => {
          const cfg = res?.data?.[0] || res?.[0];
          if (cfg && cfg.default_pay_method) {
            setFormData(prev => ({ ...prev, pay_method: cfg.default_pay_method }));
          }
        })
        .catch((err) => console.error("Error fetching store config:", err));
    }
  }, [user?.store]);
  useEffect(() => {
    setTotals(calculateTotals(productsvalue, productQuantities));
  }, [productQuantities]);
  useEffect(() => {
    const q = searchQuery.trim().toLowerCase();
    if (q !== "") {
      const map = new Map();
      allProducts.forEach((product) => {
        const titleMatch = product?.title?.toLowerCase().includes(q);
        const segs = (product?.segments || []).filter((s) => {
          const barcodeMatch = s?.segment_barcode?.toLowerCase() === q;
          return (barcodeMatch || titleMatch) && s.total_pc_in_uom === 1 && s.inventory_available;
        });
        if (segs.length > 0 && !map.has(product.id)) {
          map.set(product.id, { ...product, segments: segs });
        }
      });
      setProductsvalue(Array.from(map.values()));
    } else {
      const unique = allProducts.reduce((acc, p) => {
        if (!acc.find((x) => x.id === p.id)) {
          const segs = (p.segments || []).filter((s) => s.total_pc_in_uom === 1 && s.inventory_available);
          if (segs.length > 0) acc.push({ ...p, segments: segs });
        }
        return acc;
      }, []);
      setProductsvalue(unique);
    }
  }, [searchQuery, allProducts]);
  useEffect(() => {
    fetchProductData();
  }, []);
  useEffect(() => {
    const onFsChange = () => {
      const isFull = !!document.fullscreenElement;
      setIsFullscreen(isFull);
      if (!isFull) setTimeout(() => { document.body.style.overflow = "auto"; }, 300);
    };
    const onKeyDown = (e) => {
      if (e.key === "F11") { e.preventDefault(); toggleFullscreen(); }
    };
    document.addEventListener("fullscreenchange", onFsChange);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("fullscreenchange", onFsChange);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().then(() => {
        document.body.style.overflow = "hidden";
        setIsFullscreen(true);
      }).catch(console.error);
    } else {
      document.exitFullscreen().then(() => setIsFullscreen(false)).catch(console.error);
    }
  };
  const fetchProductData = async () => {
    if (fetchingRef.current) return;
    fetchingRef.current = true;
    try {
      setLoading(true);
      const api = `${getAPI("getProductAndInventory")}?no_pagination=true`;
      const response = await Post(api);
      const data = response?.data;
      const results = Array.isArray(data) ? data : (data?.results || []);
      const filtered = results.filter((p) => (p.segments || []).some((s) => s.total_pc_in_uom === 1 && s.inventory_available));
      setAllProducts(filtered);
      if (filtered.length > 0) {
        setFormData((prev) => ({ ...prev, invoice_no: filtered[0].next_invoice_no }));
      }
    } catch (err) {
      console.error("Error fetching products:", err);
    } finally {
      fetchingRef.current = false;
      setLoading(false);
    }
  };
  const calculateRoundOff = (amount) => {
    const dec = Math.round((amount - Math.floor(amount)) * 100) / 100;
    const rounded = dec >= 0.5 ? Math.ceil(amount) : Math.floor(amount);
    return { roundedValue: rounded, roundOff: Math.round((rounded - amount) * 100) / 100 };
  };
  const calculateTotals = (products, quantities) => {
    let totalQty = 0, totalAmount = 0;
    const productAmounts = {};
    products.forEach((p) => {
      (p.segments || []).forEach((s) => {
        const key = `${p.id}-${s.id}`;
        const qty = quantities[key] || 0;
        const price = parseFloat(s.selling_price) || 0;
        totalQty += qty;
        totalAmount += qty * price;
        productAmounts[p.id] = Number((qty * price).toFixed(2));
      });
    });
    const { roundedValue, roundOff } = calculateRoundOff(totalAmount);
    return { totalQty, totalAmount, roundedValue, roundOff, productAmounts };
  };
  const { totalAmount, roundedValue, productAmounts } = totals;
  const finalPayable = roundOffEnabled ? roundedValue : (totalAmount || 0) - additionalDiscount;
  const handleIncrement = (productId, segmentId) => {
    setProductQuantities((prev) => {
      const key = `${productId}-${segmentId}`;
      const newQty = (prev[key] || 0) + 1;
      const updated = { ...prev, [key]: newQty };
      setAddedProducts((prevAdded) => {
        const product = allProducts.find((p) => p.id === productId);
        const segment = product?.segments?.find((s) => s.id === segmentId);
        if (segment && !prevAdded.some((i) => i.id === productId && i.segment.id === segmentId)) {
          return [...prevAdded, { id: productId, title: product.title, image: product.product_image, segment: { id: segmentId, ...segment } }];
        }
        return prevAdded;
      });
      return updated;
    });
  };
  const handleDecrement = (productId, segmentId) => {
    setProductQuantities((prev) => {
      const key = `${productId}-${segmentId}`;
      const newQty = Math.max((prev[key] || 0) - 1, 0);
      const updated = { ...prev, [key]: newQty };
      if (newQty === 0) {
        setAddedProducts((prevAdded) =>
          prevAdded.filter((i) => !(i.id === productId && i.segment.id === segmentId))
        );
      }
      return updated;
    });
  };
  const updateProductCardSize = (direction) => {
    setProductCardSize((currentSize) => {
      const currentIndex = CARD_SIZE_OPTIONS.findIndex((option) => option.key === currentSize);
      const safeIndex = currentIndex >= 0 ? currentIndex : 1;
      const nextIndex = Math.min(
        Math.max(safeIndex + direction, 0),
        CARD_SIZE_OPTIONS.length - 1
      );
      const nextSize = CARD_SIZE_OPTIONS[nextIndex].key;

      try {
        window.localStorage.setItem(CARD_SIZE_STORAGE_KEY, nextSize);
      } catch (error) {
        // Card size persistence is optional; UI should still work if storage is blocked.
      }

      return nextSize;
    });
  };

  const handleRemove = (productId, segmentId) => {
    setProductQuantities((prev) => {
      const updated = { ...prev };
      delete updated[`${productId}-${segmentId}`];
      return updated;
    });
    setAddedProducts((prev) =>
      prev.filter((i) => !(i.id === productId && i.segment.id === segmentId))
    );
  };
  const handleCancel = () => {
    const reset = {};
    Object.keys(productQuantities).forEach((k) => { reset[k] = 0; });
    setProductQuantities(reset);
    setAddedProducts([]);
  };
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const dispatchToLocalTerminal = async (paymentId, dispatch, originalPayload) => {
    setTerminalStatus("CONNECTING");

    if (dispatch.type === "CLOVER_WS") {
      // This Clover terminal speaks the CloverConnector WebSocket protocol
      // ("Secure Network Pay Display") over local Wi-Fi, not REST - this
      // browser (on the same LAN as the till) pairs (first time only) and
      // sends the sale directly via Clover's official SDK.
      setTerminalMessage(`Sending amount to ${selectedTerminal?.name || "the terminal"} over Wi-Fi...`);
      try {
        const saleResponse = await runCloverLocalSale({
          uri: dispatch.uri,
          applicationId: dispatch.applicationId,
          posName: dispatch.posName,
          serialNumber: dispatch.serialNumber,
          authToken: dispatch.authToken,
          amountCents: dispatch.amount,
          externalId: dispatch.externalId,
          onPairingCode: (code) => {
            setTerminalMessage(`Pairing code on ${selectedTerminal?.name || "the terminal"}: ${code} — confirm on the terminal's screen (first time only).`);
          },
          onAuthToken: (newAuthToken) => {
            if (selectedTerminal?.id) {
              Patch("paymentTerminals", selectedTerminal.id, { clover_ws_auth_token: newAuthToken }).catch(() => {});
            }
          },
          onStatus: (msg) => setTerminalMessage(msg),
        });
        const providerTxId = saleResponse?.getPayment?.()?.getId?.() || undefined;
        Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
          status: "WAITING_FOR_CUSTOMER",
          provider_transaction_id: providerTxId,
        }).catch(() => {});
        setTerminalStatus("WAITING_FOR_CUSTOMER");
        pollTerminalPayment(paymentId, originalPayload);
      } catch (err) {
        console.error("Clover local WebSocket dispatch failed:", err);
        const failureMessage = err?.message || "Could not complete the charge on the terminal.";
        Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
          status: "FAILED",
          failure_message: failureMessage,
        }).catch(() => {});
        setTerminalStatus("FAILED");
        setTerminalMessage(failureMessage);
      }
      return;
    }

    // Legacy REST-based local dispatch (other providers/models).
    setTerminalMessage(`Sending amount to ${selectedTerminal?.name || "the terminal"}...`);

    fetch(dispatch.url, {
      method: dispatch.method || "POST",
      headers: dispatch.headers || { "Content-Type": "application/json" },
      body: JSON.stringify(dispatch.payload),
    })
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Terminal responded with status ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        const providerTxId = data.id || data.paymentId || data.transactionId;
        Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
          status: "WAITING_FOR_CUSTOMER",
          provider_transaction_id: providerTxId,
        }).catch(() => {});
        setTerminalStatus("WAITING_FOR_CUSTOMER");
        setTerminalMessage(`Please tap, insert, or swipe your card on ${selectedTerminal?.name || "the terminal"}...`);
        pollLocalTerminalStatus(paymentId, dispatch, providerTxId, originalPayload);
      })
      .catch((err) => {
        console.error("Local terminal dispatch failed:", err);
        const failureMessage =
          "Could not reach the payment terminal on your local network. Make sure the POS device and the terminal are connected to the same Wi-Fi/LAN, that the terminal app is open, and that the IP address in Settings is correct.";
        Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
          status: "FAILED",
          failure_message: failureMessage,
        }).catch(() => {});
        setTerminalStatus("FAILED");
        setTerminalMessage(failureMessage);
      });
  };

  const pollLocalTerminalStatus = (paymentId, dispatch, providerTxId, originalPayload) => {
    let attempts = 0;
    const statusUrl = dispatch.status_url ? dispatch.status_url.replace("{id}", providerTxId) : null;
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }
    pollingRef.current = setInterval(() => {
      attempts += 1;
      if (attempts > 60 || !statusUrl) {
        clearInterval(pollingRef.current);
        Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
          status: "FAILED",
          failure_message: "Payment timeout. Please try again.",
        }).catch(() => {});
        setTerminalStatus("FAILED");
        setTerminalMessage("Payment timeout. Please try again.");
        return;
      }

      fetch(statusUrl, { headers: dispatch.status_headers || {} })
        .then((res) => res.json())
        .then((data) => {
          const state = data.state;
          if (state === "PAID") {
            clearInterval(pollingRef.current);
            Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
              status: "SUCCESS",
              card_brand: data.card?.brand || "Unknown",
              masked_pan_last4: data.card?.last4 || "",
            })
              .catch(() => {})
              .finally(() => pollTerminalPayment(paymentId, originalPayload));
          } else if (state === "FAILED" || state === "DECLINED") {
            clearInterval(pollingRef.current);
            Post(`${getAPI("paymentsTerminal")}${paymentId}/report/`, {
              status: "FAILED",
              failure_message: "Payment declined or cancelled on the terminal.",
            })
              .catch(() => {})
              .finally(() => pollTerminalPayment(paymentId, originalPayload));
          } else {
            setTerminalStatus("PROCESSING");
            setTerminalMessage("Processing card payment. Please wait...");
          }
        })
        .catch((err) => {
          // Transient hiccup polling the terminal directly on the LAN; keep retrying.
          console.warn("Local terminal status poll failed, retrying:", err);
        });
    }, 2000);
  };

  const pollTerminalPayment = (paymentId, originalPayload) => {
    let attempts = 0;
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
    }
    pollingRef.current = setInterval(() => {
      attempts += 1;
      if (attempts > 60) {
        clearInterval(pollingRef.current);
        setTerminalStatus("FAILED");
        setTerminalMessage("Payment timeout. Please try again.");
        return;
      }

      Get(`${getAPI('paymentsTerminal')}${paymentId}/`)
        .then((response) => {
          const status = response.status;
          setTerminalStatus(status);
          if (status === "WAITING_FOR_CUSTOMER") {
            setTerminalMessage(`Please tap, insert, or swipe your card on ${selectedTerminal?.name || "the terminal"}...`);
          } else if (status === "PROCESSING") {
            setTerminalMessage("Processing card payment. Please wait...");
          } else if (status === "SUCCESS") {
            clearInterval(pollingRef.current);
            setTerminalMessage("Payment approved! Finalizing invoice...");
            const finalPayload = {
              ...originalPayload,
              sales_invoice: {
                ...originalPayload.sales_invoice,
                pay_method: "bank"
              }
            };
            Post("createSalesInvoice", finalPayload)
              .then((invoiceResponse) => {
                const resData = invoiceResponse.data;
                if (resData?.error) {
                  handleToast({ type: "ERROR", message: resData.error });
                  setShowTerminalModal(false);
                  return;
                }
                handleToast({ type: "SUCCESS", message: "Sales invoice created successfully!" });
                Get("getProductPosInvoice");
                setModalData(invoiceResponse.data);
                setShowInvoice(true);
                setAddedProducts([]);
                setProductsvalue([]);
                setProductQuantities({});
                setSearchQuery("");
                setAllProducts([]);
                fetchProductData();
                setShowTerminalModal(false);
              })
              .catch((err) => {
                console.error("Error creating invoice after payment:", err);
                setTerminalStatus("FAILED");
                setTerminalMessage("Payment approved, but failed to record invoice.");
              });
          } else if (status === "FAILED" || status === "CANCELLED") {
            clearInterval(pollingRef.current);
            setTerminalMessage(response.failure_message || "Payment declined or cancelled by customer.");
          }
        })
        .catch((err) => {
          console.error("Error polling payment status:", err);
        });
    }, 2000);
  };

  const handleSubmit = async (openModal = false) => {
    const filtered = addedProducts.filter(
      (p) => p.segment && productQuantities[`${p.id}-${p.segment.id}`] > 0
    );
    if (filtered.length === 0) {
      handleToast({ type: "ERROR", message: "Please add at least one product" });
      return;
    }

    if (!shiftData?.is_active) {
      // No point sending this to the backend just to get a "no active shift"
      // error back - catch it here and let the user start a shift right from
      // this popup, then continue with the same sale automatically.
      setPendingSubmitOpenModal(openModal);
      setShowShiftRequiredModal(true);
      return;
    }
    const { roundedValue: rv, roundOff: ro } = calculateRoundOff(totalAmount);
    const payload = {
      sales_invoice: {
        store: user.store,
        customer: formData.customer,
        date: formData.date,
        invoice_no: formData.invoice_no,
        pay_method: formData.pay_method,
        additional_discount_value: formData.additional_discount_value || "0",
        cheque_no: formData.cheque_no,
        bank: formData.bank,
        note: formData.note,
        round_off: roundOffEnabled ? parseFloat(ro.toFixed(2)).toFixed(2) : "0.00",
        payable_amount: parseFloat((roundOffEnabled ? rv : totalAmount).toFixed(2)),
        invoice_type: "pos",
      },
      sales_invoice_products: filtered.flatMap((p) =>
        p.segment ? [{
          store: user.store,
          product: p.segment.product_id,
          sold_qty_stock: productQuantities[`${p.id}-${p.segment.id}`] || 0,
          discount_percentage: p.segment.discount_percentage || 0,
          uom: p.segment.uom || "",
          total_pc_in_uom: p.segment.total_pc_in_uom || 1,
          amount: productAmounts?.[p.id] ?? 0,
          total: p.total || 0,
          selling_price: p.segment.selling_price || 0,
        }] : []
      ),
      inventory_clearance_pattern: "FIFO",
    };

    if (formData.pay_method === "terminal") {
      if (!selectedTerminal) {
        handleToast({ type: "ERROR", message: "Please configure a payment terminal in Settings first." });
        return;
      }
      setShowTerminalModal(true);
      setTerminalStatus("CONNECTING");
      setTerminalMessage(`Connecting to ${selectedTerminal.name}...`);
      
      const payableAmount = parseFloat((roundOffEnabled ? rv : totalAmount).toFixed(2));

      Post("paymentsTerminal", {
        store_id: user.store,
        terminal_id: selectedTerminal.id,
        amount_minor: Math.round(payableAmount * 100)
      })
        .then((response) => {
          const data = response.data;
          if (data.dispatch && data.dispatch.required) {
            // Real LOCAL_LAN terminal: our backend server cannot reach the store's
            // private network, so THIS browser (on the same LAN as the terminal)
            // sends the amount to the device directly.
            dispatchToLocalTerminal(data.payment_id, data.dispatch, payload);
          } else {
            pollTerminalPayment(data.payment_id, payload);
          }
        })
        .catch((err) => {
          console.error("Error initiating payment:", err);
          setTerminalStatus("FAILED");
          setTerminalMessage(err.response?.data?.detail || "Failed to initiate payment on terminal.");
        });
      return;
    }

    Post("createSalesInvoice", payload)
      .then((response) => {
        const resData = response.data;
        if (resData?.error) {
          handleToast({ type: "ERROR", message: resData.error });
          return;
        }
        handleToast({ type: "SUCCESS", message: "Sales invoice created successfully!" });
        Get("getProductPosInvoice");
        if (openModal) { setModalData(response.data); setShowInvoice(true); }
        setAddedProducts([]);
        setProductsvalue([]);
        setProductQuantities({});
        setSearchQuery("");
        setAllProducts([]);
        fetchProductData();
      })
      .catch((err) => {
        const msg = err?.response?.data?.error || "Failed to create sales invoice.";
        handleToast({ type: "ERROR", message: msg });
      });
  };
  const handleStartShiftAndContinueSale = async () => {
    setStartingShiftForSale(true);
    try {
      const result = await startShift();
      if (result?.success) {
        setShowShiftRequiredModal(false);
        handleToast({ type: "SUCCESS", message: "Shift started." });
        // Re-run the same sale now that a shift is active.
        handleSubmit(pendingSubmitOpenModal);
      } else {
        handleToast({ type: "ERROR", message: result?.error || "Could not start shift. Please try again." });
      }
    } catch (err) {
      console.error("Error starting shift from sale:", err);
      handleToast({ type: "ERROR", message: "Could not start shift. Please try again." });
    } finally {
      setStartingShiftForSale(false);
    }
  };

  const handlePrint = async (invoiceId, openModal = false) => {
    try {
      const response = await Post("getSalesInvoiceDetails", { invoice_id: invoiceId });
      if (response?.data && openModal) { setModalData(response.data); setShowInvoice(true); }
    } catch (err) {
      console.error("Error fetching invoice details:", err);
    }
  };
  if (loading) return <LoadingOverlay loading={loading} loader={loader} />;

  const PAY_METHODS = [
    { key: "cash", label: "Cash" },
    { key: "bank", label: "Bank Card" },
    { key: "cheque", label: "Cheque" },
    { key: "terminal", label: "Terminal" },
  ];
  const activeCardSizeIndex = CARD_SIZE_OPTIONS.findIndex((option) => option.key === productCardSize);
  const activeCardSizeLabel = CARD_SIZE_OPTIONS[activeCardSizeIndex >= 0 ? activeCardSizeIndex : 1].label;

  return (
    <div className="responsive-box pqi-kiosk-page" id="dashboard-container">
      <ToastContainer />

      <div className={`pqi-wrapper${isFullscreen ? " fullscreen" : ""}`}>
        <div className="pqi-left">
          <div className="pqi-left-header">
            <div className="pqi-heading-area">
              <span className="pqi-kiosk-chip">Kiosk</span>
              <div>
                <h1 className="pqi-title">Quick Invoice</h1>
                <p className="pqi-title-note">Scan, select, checkout.</p>
              </div>
            </div>

            <div className="pqi-meta">
              <div className="pqi-meta-row">
                <img src={dateIcon} alt="date" />
                <CustomDateInput
                  value={formData.date}
                  onChange={handleFormChange}
                  required
                  readOnly
                  inputStyle={{
                    border: "none",
                    background: "transparent",
                    color: "#111827",
                    fontFamily: "Inter, Quicksand, sans-serif",
                    fontSize: "13px",
                    fontWeight: 700,
                    width: "118px",
                    minWidth: "118px",
                    maxWidth: "118px",
                    outline: "none",
                  }}
                />
              </div>

              <div className="pqi-meta-row">
                <img src={invoiceIcon} alt="invoice" />
                <span>#INV</span>
                <input
                  type="text"
                  name="invoice_no"
                  value={formData.invoice_no}
                  readOnly
                  onChange={handleFormChange}
                />
              </div>

              <button className="pqi-fullscreen-btn" onClick={toggleFullscreen} type="button">
                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  {isFullscreen ? (
                    <>
                      <path d="M9 3v6H3" />
                      <path d="M15 3v6h6" />
                      <path d="M9 21v-6H3" />
                      <path d="M15 21v-6h6" />
                    </>
                  ) : (
                    <>
                      <path d="M8 3H3v5" />
                      <path d="M16 3h5v5" />
                      <path d="M8 21H3v-5" />
                      <path d="M16 21h5v-5" />
                    </>
                  )}
                </svg>
                {isFullscreen ? "Exit" : "Fullscreen"}
              </button>
            </div>
          </div>

          <div className="pqi-search-wrap">
            <div className="pqi-search-inner">
              <svg className="pqi-search-icon" width="20" height="20" viewBox="0 0 22 22" fill="none" aria-hidden="true">
                <path d="M10.5416 19.2497C15.3511 19.2497 19.2499 15.3508 19.2499 10.5413C19.2499 5.73186 15.3511 1.83301 10.5416 1.83301C5.73211 1.83301 1.83325 5.73186 1.83325 10.5413C1.83325 15.3508 5.73211 19.2497 10.5416 19.2497Z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20.1666 20.1663L18.3333 18.333" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
              </svg>

              <input
                type="text"
                placeholder="Search product or scan barcode…"
                value={searchQuery}
                autoComplete="off"
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const q = searchQuery.trim().toLowerCase();
                    const found = productsvalue.find((p) => p.title?.toLowerCase().includes(q));
                    if (found?.segments?.length > 0) handleIncrement(found.id, found.segments[0].id);
                    e.preventDefault();
                  }
                }}
              />
            </div>

            <div className="pqi-search-actions">
              <div className="pqi-live-stats">
                <span><strong>{productsvalue.length}</strong> products</span>
                <span><strong>{totals.totalQty || 0}</strong> selected</span>
              </div>

              <div className="pqi-card-size-control" aria-label="Product card size control">
                <span>Card</span>
                <button
                  type="button"
                  onClick={() => updateProductCardSize(-1)}
                  disabled={activeCardSizeIndex <= 0}
                  aria-label="Decrease product card size"
                >−</button>
                <strong>{activeCardSizeLabel}</strong>
                <button
                  type="button"
                  onClick={() => updateProductCardSize(1)}
                  disabled={activeCardSizeIndex >= CARD_SIZE_OPTIONS.length - 1}
                  aria-label="Increase product card size"
                >+</button>
              </div>
            </div>
          </div>

          <div className={`pqi-products-grid pqi-card-size-${productCardSize}`}>
            {!loading && productsvalue.length === 0 ? (
              <div className="pqi-empty-msg">
                <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="11" cy="11" r="7" />
                  <path d="m21 21-4.3-4.3" />
                </svg>
                <strong>{searchQuery.trim() ? "No matching products found" : "No products available"}</strong>
                <span>{searchQuery.trim() ? "Try another product name or scan a valid barcode." : "Available inventory products will appear here."}</span>
              </div>
            ) : (
              productsvalue.map((product) =>
                (product.segments || []).map((segment) => {
                  const key = `${product.id}-${segment.id}`;
                  const qty = productQuantities[key] || 0;
                  const price = parseFloat(segment.selling_price) || 0;

                  return (
                    <div
                      key={key}
                      className={`pqi-product-card${qty > 0 ? " has-qty" : ""}`}
                      onClick={() => handleIncrement(product.id, segment.id)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleIncrement(product.id, segment.id);
                        }
                      }}
                    >
                      {qty > 0 && <span className="pqi-selected-badge">{qty}</span>}

                      <div className="pqi-product-img-frame">
                        <img
                          src={product.product_image ? `${getHost()}${product.product_image}` : defaultImage}
                          alt={product.title}
                          className="pqi-product-img"
                          onError={(e) => { e.target.src = defaultImage; }}
                        />
                      </div>

                      <div className="pqi-product-content">
                        <p className="pqi-product-name" title={product.title}>{product.title}</p>
                        <p className="pqi-product-uom">{segment.uom_title} ({segment.total_pc_in_uom})</p>
                        <p className="pqi-product-price">{formatCurrency(price)}</p>
                      </div>

                      <div className="pqi-qty-controls">
                        <button
                          className="pqi-qty-btn"
                          type="button"
                          onClick={(e) => { e.stopPropagation(); handleDecrement(product.id, segment.id); }}
                          aria-label={`Decrease ${product.title}`}
                        >−</button>
                        <span className="pqi-qty-val">{qty}</span>
                        <button
                          className="pqi-qty-btn"
                          type="button"
                          onClick={(e) => { e.stopPropagation(); handleIncrement(product.id, segment.id); }}
                          aria-label={`Increase ${product.title}`}
                        >+</button>
                      </div>
                    </div>
                  );
                })
              )
            )}
          </div>
        </div>

        <div className="pqi-right">
          <div className="pqi-cart-header">
            <div className="pqi-cart-title-block">
              <span className="pqi-cart-kicker">Current Bill</span>
              <h2>Order Summary</h2>
            </div>
            <button className="pqi-clear-btn" onClick={handleCancel} type="button">Clear</button>
          </div>

          <div className="pqi-cart-total-strip">
            <div className="pqi-cart-stat">
              <span className="pqi-cart-stat-label">Items</span>
              <span className="pqi-cart-stat-value">{totals.totalQty || 0}</span>
            </div>
            <div className="pqi-cart-stat primary">
              <span className="pqi-cart-stat-label">Payable</span>
              <span className="pqi-cart-stat-value">
                {formatCurrency(
                  typeof finalPayable === "number" && !isNaN(finalPayable)
                    ? finalPayable.toFixed(2)
                    : "0.00"
                )}
              </span>
            </div>
          </div>

          <div className="pqi-cart-list">
            {addedProducts.length === 0 ? (
              <div className="pqi-cart-empty">
                <span className="pqi-cart-empty-icon">
                  <svg width="46" height="46" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M15 17h26l-3.2 13.2a4 4 0 0 1-3.9 3.1H18.4a4 4 0 0 1-3.9-3.2L10.8 9H6" />
                    <circle cx="19" cy="40" r="2.5" fill="currentColor" stroke="none" />
                    <circle cx="34" cy="40" r="2.5" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <strong>No products added yet</strong>
                <span>Tap products from the left to build this bill.</span>
              </div>
            ) : (
              addedProducts.map(({ id, title, image, segment }) => {
                const qty = productQuantities[`${id}-${segment.id}`] || 0;
                const total = (qty * (segment.selling_price || 0)).toFixed(2);

                return (
                  <div key={`${id}-${segment.id}`} className="pqi-cart-item">
                    <div className="pqi-cart-img-wrap">
                      <img
                        src={image ? `${getHost()}${image}` : defaultImage}
                        alt={title}
                        className="pqi-cart-img"
                        onError={(e) => { e.target.src = defaultImage; }}
                      />
                    </div>

                    <div className="pqi-cart-info">
                      <p className="pqi-cart-name">{title}</p>
                      <p className="pqi-cart-uom">{segment.uom_title}</p>
                    </div>

                    <div className="pqi-cart-qty-wrap">
                      <button className="pqi-cart-qty-btn" onClick={() => handleDecrement(id, segment.id)} type="button">−</button>
                      <span className="pqi-cart-qty-num">{qty}</span>
                      <button className="pqi-cart-qty-btn" onClick={() => handleIncrement(id, segment.id)} type="button">+</button>
                    </div>

                    <div className="pqi-cart-price-col">
                      <p className="pqi-cart-total">{formatCurrency(total)}</p>
                      <p className="pqi-cart-rate">@ {formatCurrency(segment.selling_price || 0)}</p>
                    </div>

                    <button className="pqi-cart-del-btn" onClick={() => handleRemove(id, segment.id)} type="button" aria-label={`Remove ${title}`}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14H6L5 6" />
                        <path d="M10 11v6M14 11v6" />
                        <path d="M9 6V4h6v2" />
                      </svg>
                    </button>
                  </div>
                );
              })
            )}
          </div>

          <div className="pqi-payment-footer">
            <div className="pqi-payment-row">
              <div className="pqi-payment-block">
                <p className="pqi-payment-label">Payment Method</p>
                <div className="pqi-pill-group">
                  {PAY_METHODS.map(({ key, label }) => (
                    <button
                      key={key}
                      type="button"
                      className={`pqi-pill${formData.pay_method === key ? " active" : ""}`}
                      onClick={() => setFormData((prev) => ({ ...prev, pay_method: key }))}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="pqi-payment-block pqi-roundoff-block">
                <p className="pqi-payment-label">Round Off</p>
                <div className="pqi-pill-group compact">
                  <button
                    type="button"
                    className={`pqi-pill${roundOffEnabled ? " active" : ""}`}
                    onClick={() => setRoundOffEnabled(true)}
                  >Yes</button>
                  <button
                    type="button"
                    className={`pqi-pill${!roundOffEnabled ? " active" : ""}`}
                    onClick={() => setRoundOffEnabled(false)}
                  >No</button>
                </div>
              </div>
            </div>

            {formData.pay_method === "terminal" && (
              <div className="pqi-payment-block" style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <p className="pqi-payment-label">Select Terminal</p>
                {terminals.length > 0 ? (
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '12px' }}>
                    {selectedTerminal && (
                      <img 
                        src={
                          selectedTerminal.provider === "CLOVER" ? "https://cloverstatic.com/web/apps/cloverdotcom/release::v2.142.0-f81e9288a386b/assets/media/clover-logo.5637c88fda21055b797e300e16140c95.svg" :
                          selectedTerminal.provider === "STRIPE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/330px-Stripe_Logo%2C_revised_2016.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "SQUARE" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3d/Square%2C_Inc._logo.svg/3840px-Square%2C_Inc._logo.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" :
                          selectedTerminal.provider === "ADYEN" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLwbTNAl15w8i2X2hvS1FQlVFTRuJbEAoi_m2aUJwGJ1RhL18li_Po4fQ&s=10" :
                          selectedTerminal.provider === "PINE_LABS" ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSWMtmHPJkKFRxPBaCiw49vdQNLgBaxtG9Ls2hwYr2LY2RXP0KkMsG9WcJ&s=10" :
                          selectedTerminal.provider === "PAYTM" ? "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Paytm_Logo_%28standalone%29.svg/1280px-Paytm_Logo_%28standalone%29.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail" : ""
                        } 
                        alt={selectedTerminal.provider} 
                        style={{ height: '24px', maxWidth: '80px', objectFit: 'contain' }} 
                      />
                    )}
                    <select
                      value={selectedTerminal?.id || ""}
                      onChange={(e) => {
                        const found = terminals.find(t => t.id === e.target.value);
                        setSelectedTerminal(found);
                      }}
                      style={{
                        padding: '8px 12px',
                        borderRadius: '8px',
                        border: '1px solid #cbd5e1',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        background: '#ffffff',
                        color: '#0f172a',
                        outline: 'none',
                        width: '240px'
                      }}
                    >
                      {terminals.map(t => (
                        <option key={t.id} value={t.id}>{t.name} ({t.provider})</option>
                      ))}
                    </select>
                  </div>
                ) : (
                  <span style={{ fontSize: '13px', color: '#dc2626', fontWeight: 'bold', marginBottom: '12px' }}>
                    No active terminals. Please configure a terminal in Settings.
                  </span>
                )}
              </div>
            )}

            <button className="pqi-save-btn" onClick={() => handleSubmit(true)} type="button">
              <span className="pqi-save-main">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M6 9V2h12v7" />
                  <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                  <path d="M6 14h12v8H6z" />
                </svg>
                Save &amp; Print
              </span>
              <strong>
                {formatCurrency(
                  typeof finalPayable === "number" && !isNaN(finalPayable)
                    ? finalPayable.toFixed(2)
                    : "0.00"
                )}
              </strong>
            </button>
          </div>
        </div>
      </div>

      <QuickInvoicemodal
        open={showInvoice}
        onClose={() => setShowInvoice(false)}
        data={modalData}
        onPrint={handlePrint}
        invoiceType="pos"
        style={{ zIndex: 1100, position: "relative" }}
      />

      {showTerminalModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.6)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: '#ffffff',
            padding: '30px',
            borderRadius: '12px',
            width: '400px',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>
              {terminalStatus === "CONNECTING" && "🔌"}
              {terminalStatus === "WAITING_FOR_CUSTOMER" && "💳"}
              {terminalStatus === "PROCESSING" && "🔄"}
              {terminalStatus === "SUCCESS" && "✅"}
              {terminalStatus === "FAILED" && "❌"}
            </div>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '20px', color: '#0f172a' }}>
              {terminalStatus === "CONNECTING" && "Connecting to Terminal"}
              {terminalStatus === "WAITING_FOR_CUSTOMER" && "Swipe / Tap / Insert Card"}
              {terminalStatus === "PROCESSING" && "Processing Payment"}
              {terminalStatus === "SUCCESS" && "Payment Successful"}
              {terminalStatus === "FAILED" && "Payment Failed"}
            </h3>
            <p style={{ color: '#475569', fontSize: '14px', margin: '0 0 20px 0', minHeight: '40px', lineHeight: '1.5' }}>
              {terminalMessage}
            </p>
            {terminalStatus === "WAITING_FOR_CUSTOMER" && selectedTerminal && (
              <div style={{ margin: '0 0 20px 0', padding: '10px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe' }}>
                <a 
                  href={
                    selectedTerminal.provider === "CLOVER" ? "https://sandbox.dev.clover.com/" :
                    selectedTerminal.provider === "STRIPE" ? "https://stripe.com/docs/terminal/references/testing#simulated-reader" :
                    selectedTerminal.provider === "SQUARE" ? "https://developer.squareup.com/docs/terminal-api/testing" :
                    selectedTerminal.provider === "ADYEN" ? "https://docs.adyen.com/point-of-sale/testing-terminals" :
                    selectedTerminal.provider === "PINE_LABS" ? "https://developer.pinelabs.com/" :
                    selectedTerminal.provider === "PAYTM" ? "https://developer.paytm.com/docs/pos/" : "#"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: '13px', color: '#1d4ed8', fontWeight: 'bold', textDecoration: 'underline' }}
                >
                  👉 Open {selectedTerminal.provider} Simulator / Testing Docs
                </a>
              </div>
            )}
            {terminalStatus === "FAILED" && (
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                <button
                  onClick={() => handleSubmit(true)}
                  style={{
                    padding: '8px 16px',
                    background: '#0284c7',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  Try Again
                </button>
                <button
                  onClick={() => {
                    if (pollingRef.current) clearInterval(pollingRef.current);
                    setShowTerminalModal(false);
                  }}
                  style={{
                    padding: '8px 16px',
                    background: '#cbd5e1',
                    color: '#334155',
                    border: 'none',
                    borderRadius: '6px',
                    fontWeight: 'bold',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
            {terminalStatus !== "FAILED" && terminalStatus !== "SUCCESS" && (
              <button
                onClick={() => {
                  if (pollingRef.current) clearInterval(pollingRef.current);
                  setShowTerminalModal(false);
                }}
                style={{
                  padding: '8px 16px',
                  background: '#cbd5e1',
                  color: '#334155',
                  border: 'none',
                  borderRadius: '6px',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      )}

      {showShiftRequiredModal && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(15, 23, 42, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
            padding: "16px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "16px",
              padding: "28px",
              maxWidth: "420px",
              width: "100%",
              textAlign: "center",
              boxShadow: "0 24px 60px rgba(15, 23, 42, 0.25)",
            }}
          >
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                background: "#eefbf2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: "26px",
              }}
            >
              🕒
            </div>
            <h3 style={{ margin: "0 0 8px", fontSize: "18px", fontWeight: 850, color: "#0f172a" }}>
              Start a shift to make this sale
            </h3>
            <p style={{ margin: "0 0 22px", fontSize: "14px", color: "#64748b" }}>
              Sales can only be recorded while a shift is active. Start one now and this sale will go through right after.
            </p>
            <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
              <button
                type="button"
                onClick={() => setShowShiftRequiredModal(false)}
                disabled={startingShiftForSale}
                className="pqi-modal-cancel-btn"
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  background: "#fff",
                  color: "#334155",
                  fontWeight: 700,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleStartShiftAndContinueSale}
                disabled={startingShiftForSale}
                style={{
                  padding: "10px 24px",
                  borderRadius: "10px",
                  border: "none",
                  background: startingShiftForSale ? "#94a3b8" : "#16a34a",
                  color: "#fff",
                  fontWeight: 800,
                  cursor: startingShiftForSale ? "not-allowed" : "pointer",
                }}
              >
                {startingShiftForSale ? "Starting Shift..." : "Start Shift & Sell"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div ref={mainContainerRef} className="your-scrollable-container pqi-transaction-drawer-shell">
        <SwipeInComponent
          onDragEnd={(isOpen) => setIsSwipeOpen(isOpen)}
          onClose={() => setIsSwipeOpen(false)}
          isOpen={isSwipeOpen}
          setIsOpen={setIsSwipeOpen}
          scrollPosition={scrollPosition}
          parentRef={mainContainerRef}
          loading={loading}
        />
      </div>
    </div>
  );
}
export default PosQuickInvoice;
